import { IUrlProvider } from '../../url.provider';
import { UserService } from '../../../../../service/user.service';
import { map, Observable } from 'rxjs';
import { DownloadType } from '../../../dto/enum/download-type.enum';
import { IUrlProviderDTO } from '../../../dto/url-provider.dto';
import { IUserDTO } from '../../../../../dto/user/user.dto';
import { inject, Injectable } from '@angular/core';
import { IUrlProviderUserDTO } from '../../../dto/url-provider-user.dto';

@Injectable({
  providedIn: 'root',
})
export class AvatarUrlProvider implements IUrlProvider {
  private static readonly CAPTCHA_ACTION: 'fetchUser' = 'fetchUser' as const;
  private readonly userService: UserService = inject(UserService);

  public getCaptchaAction = (): string => AvatarUrlProvider.CAPTCHA_ACTION;

  public getCaptchaCData = (payload: string): string => payload;

  public getType = (): DownloadType => DownloadType.AVATAR;

  public getUrls(
    payload: string,
    captchaToken: string
  ): Observable<IUrlProviderDTO> {
    return this.userService.fetchUserByUsername(payload, captchaToken).pipe(
      map((userDTO: IUserDTO): IUrlProviderDTO => {
        const urls: string[] = [];
        if (userDTO.pictures.length) {
          urls.push(userDTO.pictures[0].url);
        }
        return {
          user: this.ofUserDTO(userDTO),
          urls: urls,
        };
      })
    );
  }

  private ofUserDTO(userDTO: IUserDTO): IUrlProviderUserDTO {
    return {
      primaryKey: userDTO.primaryKey,
      username: userDTO.username,
      fullName: userDTO.fullName,
      pictureUrl: userDTO.pictures[0]?.url,
      private: userDTO.private,
      verified: userDTO.verified,
    };
  }
}
